import {GenericService} from '@/shared/xhttp';
import {Contact} from '@/models';

export class ContactService extends GenericService<Contact> {
}